export default __webpack_public_path__ + "static/media/nut_set.07ed5d87.jpg";